import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

console.log('[TE Tracker] API Base URL:', BASE_URL);

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('te_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  console.log(`[API] → ${cfg.method?.toUpperCase()} ${cfg.baseURL}${cfg.url}`, cfg.data || '');
  return cfg;
});

api.interceptors.response.use(
  res => {
    console.log(`[API] ← ${res.status} ${res.config.url}`);
    return res;
  },
  err => {
    const status  = err.response?.status;
    const message = err.response?.data?.message || err.message;
    const url     = err.config?.url;
    console.error(`[API] ✗ ${status || 'NETWORK ERROR'} ${url} — ${message}`, err.response?.data || err.message);

    // Only redirect on 401 if it's NOT the login endpoint itself
    if (status === 401 && !url?.includes('/auth/login')) {
      localStorage.removeItem('te_token');
      localStorage.removeItem('te_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;